export default __webpack_public_path__ + "static/media/Image 5.50a7ecab.png";